import { m, useMotionValue, useSpring } from 'motion/react'
import type { PropsWithChildren } from 'react'

// Magnetic pull toward the cursor, poch.studio and jamm.co's signature on
// every pill button and nav link. Pointer position within the element is
// scaled down (0.35) and eased through a spring, so it nudges toward the
// cursor rather than snapping to it, and springs back to center on leave.
export function Magnetic({
  children,
  className = '',
  strength = 0.35,
}: PropsWithChildren<{ className?: string; strength?: number }>) {
  const x = useMotionValue(0)
  const y = useMotionValue(0)
  const springX = useSpring(x, { stiffness: 200, damping: 15, mass: 0.4 })
  const springY = useSpring(y, { stiffness: 200, damping: 15, mass: 0.4 })

  function onMove(e: React.MouseEvent<HTMLDivElement>) {
    const rect = e.currentTarget.getBoundingClientRect()
    x.set((e.clientX - rect.left - rect.width / 2) * strength)
    y.set((e.clientY - rect.top - rect.height / 2) * strength)
  }

  function onLeave() {
    x.set(0)
    y.set(0)
  }

  return (
    <m.div
      className={`w-fit ${className}`}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      style={{ x: springX, y: springY }}
    >
      {children}
    </m.div>
  )
}
